import { TEMPLETE_URL } from '../CONSTANT.js'
import { SNACK_LADDER_URL } from '../CONSTANT.js'
import { SYSTEM_ERROR } from '../Config/CONSTANT.js';
import axios from 'axios'
import Cookies from 'universal-cookie';

const cook = new Cookies().get('loginData')


const headersdata = {
    'content-type': 'application/json',
    'Accept': 'application/json',
    'Authorization': cook != undefined ? cook.accessToken : ''
}


export const addGameTemplete = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(TEMPLETE_URL(), data, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in addGameTemplete axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const updateTempleteDetails = (id, data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .put(TEMPLETE_URL() + id, data, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in addGameTemplete axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const getTempleteList = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(TEMPLETE_URL() + "list", data, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in addGameTemplete axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const getTempleteDetails = (id) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .get(TEMPLETE_URL() + id, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in addGameTemplete axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const deleteTemplete = (id) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .delete(TEMPLETE_URL() + id,{ headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in addGameTemplete axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const activateTemplete = (id) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .put(TEMPLETE_URL() + "activate/" + id, {}, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in addGameTemplete axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const deactivateTemplete = (id) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .put(TEMPLETE_URL() + "deactivate/" + id, {}, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in addGameTemplete axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};
export const startGame = (id) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .get(TEMPLETE_URL() + "startGame/" + id, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in addGameTemplete axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};
export const getSnakeList = (id) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .get(SNACK_LADDER_URL() + "list/" + id, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in addGameTemplete axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};
export const getLadderList = (id) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .get(SNACK_LADDER_URL() + "list/" + id, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in addGameTemplete axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};
export const getBoardList = (id) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .get(SNACK_LADDER_URL() + "list/" + id, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in addGameTemplete axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};
export const publishTemplete = (id) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .get(TEMPLETE_URL() + "publishTemplate/" + id, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in addGameTemplete axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};
export const unPublishTemplete = (id) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .get(TEMPLETE_URL() + "unPublishTemplate/" + id, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in addGameTemplete axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};